import React from 'react';
import PropTypes from 'prop-types';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import { analyticsChartTheme } from 'util/chartUtils';
import IntlMessages from '../../../../util/IntlMessages';
import DashboardPanel from './DashboardPanel';
import DashboardDonut from './DashboardDonut';
import styles from './DashboardChart.module.scss';

const Carts = ({ withProducts }) => {
  const localizeMessage = useLocalizedMessage();
  const empty = !withProducts || Boolean(withProducts.error);
  const model = withProducts || {};
  const data = [
    { name: localizeMessage('dashboard.carts.chart.fromSearch'), value: model.cartsSearch || 0, color: analyticsChartTheme.searches },
    { name: localizeMessage('dashboard.carts.chart.otherDiscovery'), value: model.cartsNoSearch || 0, color: analyticsChartTheme.previous },
  ];

  return (
    <DashboardPanel
      title={<IntlMessages id="dashboard.carts.header" />}
      subtitle={<IntlMessages id="dashboard.carts.subheader" />}
      note={<IntlMessages id="dashboard.carts.subsubheader" />}
      tone="clickEvents"
      empty={empty}
      emptyVariant="donut"
    >
      <div className={styles.split}>
        <div>
          <p className={styles.lead}>
            {`${model.cartsSearchPercentage || 0}% `}
            <IntlMessages id="dashboard.carts.text.ofProductsInCarts" />
          </p>
          <dl className={styles.metricList}>
            <div className={styles.metricRow}>
              <dt><IntlMessages id="dashboard.carts.table.totalProducts" /></dt>
              <dd>{model.cartsTotal || 0}</dd>
            </div>
            <div className={styles.metricRow}>
              <dt><IntlMessages id="dashboard.carts.table.discoveredFromSearch" /></dt>
              <dd>{model.cartsSearch || 0}</dd>
            </div>
          </dl>
        </div>
        <DashboardDonut data={data} centerLabel={`${model.cartsSearchPercentage || 0}%`} />
      </div>
    </DashboardPanel>
  );
};

Carts.propTypes = {
  withProducts: PropTypes.shape({
    cartsNoSearch: PropTypes.number,
    cartsSearch: PropTypes.number,
    cartsSearchPercentage: PropTypes.number,
    cartsTotal: PropTypes.number,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
};

Carts.defaultProps = { withProducts: null };

export default Carts;
